'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _Grid = require('@material-ui/core/Grid');
var _Grid2 = _interopRequireDefault(_Grid);
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _reactI18next = require('react-i18next');
var _Paginator = require('../Paginator');
var _Paginator2 = _interopRequireDefault(_Paginator);
var _CustomModal = require('../CustomModal');
var _CustomModal2 = _interopRequireDefault(_CustomModal);
var _styles = require('@material-ui/core/styles');
var _TextField = require('@material-ui/core/TextField');
var _TextField2 = _interopRequireDefault(_TextField);
var _Input = require('@material-ui/core/Input');
var _Input2 = _interopRequireDefault(_Input);
var _InputLabel = require('@material-ui/core/InputLabel');
var _InputLabel2 = _interopRequireDefault(_InputLabel);
var _FormControl = require('@material-ui/core/FormControl');
var _FormControl2 = _interopRequireDefault(_FormControl);
var _FormHelperText = require('@material-ui/core/FormHelperText');
var _FormHelperText2 = _interopRequireDefault(_FormHelperText);
var _FormGroup = require('@material-ui/core/FormGroup');
var _FormGroup2 = _interopRequireDefault(_FormGroup);
var _FormControlLabel = require('@material-ui/core/FormControlLabel');
var _FormControlLabel2 = _interopRequireDefault(_FormControlLabel);
var _Menu = require('@material-ui/core/Menu');
var _Menu2 = _interopRequireDefault(_Menu);
var _MenuItem = require('@material-ui/core/MenuItem');
var _MenuItem2 = _interopRequireDefault(_MenuItem);
var _Select = require('@material-ui/core/Select');
var _Select2 = _interopRequireDefault(_Select);
var _Button = require('@material-ui/core/Button');
var _Button2 = _interopRequireDefault(_Button);
var _misc = require('../../helpers/misc');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  ExhibitorsGrid: {
    textAlign: 'center',
    margin: 'auto',
    padding: '1rem',
    marginTop: '2rem'
  },
  gridInputs: {},
  paper: {
    backgroundColor: '#FFFFFF',
    position: 'absolute',
    width: '75%',
    maxWidth: '85%',
    boxShadow: '0 0 16px #B4B4B4',
    padding: '1rem',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    maxHeight: '85%'
  },
  modalExhibitor: {
    width: '90%',
    margin: '0 auto',
    fontSize: function fontSize(_ref) {
      var responsiveMode = _ref.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '16px' : '14px';
    },
    '& .img-wrapper': {
      display: 'block',
      '& .modal-logo': {
        height: '7rem',
        maxWidth: '100%',
        textAlign: 'center',
        display: 'block',
        objectFit: 'contain',
        margin: 'auto'
      }
    },
    '& .modal-info': {
      '& .modal-paragraph': {
        '& span': {
          display: 'block',
          '& .profile-custom-field-image': {
            maxWidth: '80%',
            objectFit: 'contain'
          }
        }
      }
    }
  },
  searchPanel: {
    width: function width(_ref2) {
      var responsiveMode = _ref2.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? 'auto' : '100%';
    },
    marginBottom: '3rem'
  },
  formControl: {
    width: '100%',
    marginBottom: '1rem'
  },
  inputZone: {
    fontFamily: 'inherit',
    textAlign: 'left',
    '& .selectPlaceholder': {
      color: '#BFBFBF',
      fontWeight: 'normal'
    }
  },
  inputCategory: {
    fontFamily: 'inherit',
    textAlign: 'left',
    '& .selectPlaceholder': {
      color: '#BFBFBF',
      fontWeight: 'normal'
    }
  },
  inputCompany: {
    fontFamily: 'inherit',
    marginBottom: '1rem',
    '& label': {
      color: '#BFBFBF',
      fontWeight: 'normal'
    }
  },
  inputCompanyInput: {
    '&::placeholder': {
      fontWeight: 'normal',
      color: '#BFBFBF',
      padding: '0 0 0 1rem',
      opacity: '1' /* Firefox */
    },
    '&:-ms-input-placeholder': {
      /* Internet Explorer 10-11 */
      fontWeight: 'normal',
      color: '#BFBFBF',
      padding: '0 0 0 1rem'
    },
    '&::-ms-input-placeholder': {
      /* Microsoft Edge */
      fontWeight: 'normal',
      color: '#BFBFBF',
      padding: '0 0 0 1rem'
    }
  },
  selectPlaceholder: {
    paddingLeft: '1rem',
    color: '#BFBFBF',
    fontWeight: 'normal'
  },
  button: {
    height: '3rem',
    border: '2px solid #FDAB2B',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    margin: '0.5rem',
    fontFamily: 'inherit'
  },
  searchButton: {
    color: '#FFFFFF',
    margin: '1rem',
    backgroundColor: '#FDAB2B',
    '&:hover': {
      backgroundColor: '#FDAB2B'
    }
  },
  resetButton: {
    color: '#D35B34',
    margin: '1rem',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#FFFFFF'
    }
  },
  grid: {
    margin: 'auto -12px'
  },
  exhibitor: {
    margin: '20px auto',
    minHeight: '13rem',
    height: '13rem',
    position: 'relative',
    padding: '0.5rem',
    border: '2px solid #f1f1f1',
    maxWidth: '15rem',
    pointerEvents: function pointerEvents(_ref3) {
      var editable = _ref3.editable;
      return !editable ? 'auto' : 'none';
    },
    '& .stand-identifier': {
      padding: '5px',
      backgroundColor: '#BFBFBF',
      margin: '0 auto',
      marginTop: '-30px',
      height: '2rem',
      verticalAlign: 'middle',
      color: '#eeeeee',
      zIndex: '20'
    },
    '& .info': {
      padding: '0.6rem 0',
      color: '#9a9a9a',
      '& .img-wrapper': {
        margin: '0 auto',
        display: 'table',
        '& .logo': {
          height: '7rem',
          width: '100%',
          textAlign: 'center',
          display: 'block',
          objectFit: 'contain'
        }
      },
      '& .specific-info': {
        '& .company-name': {
          marginBottom: '0px',
          textTransform: 'uppercase',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap'
        },
        '& .zone-name': {
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap'
        }
      }
    },
    '&:hover': {
      cursor: 'pointer',
      border: function border(_ref4) {
        var editable = _ref4.editable;
        return !editable && '2px solid #FDAB2B';
      },
      boxShadow: function boxShadow(_ref5) {
        var editable = _ref5.editable;
        return !editable && '0 0 16px #B4B4B4';
      },
      '& .stand-identifier': {
        backgroundColor: function backgroundColor(_ref6) {
          var editable = _ref6.editable;
          return !editable && '#FDAB2B';
        }
      }
    }
  },
  noExhibitor: {
    padding: '2rem'
  },
  progress: {
    margin: '0 auto'
  }
};
var ExhibitorsGrid = function (_Component) {
  _inherits(ExhibitorsGrid, _Component);
  function ExhibitorsGrid(props) {
    _classCallCheck(this, ExhibitorsGrid);
    var _this = _possibleConstructorReturn(this, (ExhibitorsGrid.__proto__ || Object.getPrototypeOf(ExhibitorsGrid)).call(this, props));
    _this.isURL = function (string) {
      var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
      return regexp.test(string);
    };
    _this.cleanString = function (s) {
      var cleaned = (s.charAt(0).toUpperCase() + s.slice(1)).replace(/([A-Z])|\|/g, ' $1');
      return cleaned;
    };
    _this.handleClose = function () {
      _this.setState({
        currentSRId: 0
      });
    };
    _this.handleChange = function (name) {
      return function (event) {
        _this.setState(_defineProperty({}, name, event.target.value));
      };
    };
    _this.showModal = function (id) {
      _this.setState({
        currentSRId: id
      });
    };
    _this.handleSubmit = function () {
      var _this$state = _this.state,
        zone = _this$state.inputZone,
        category = _this$state.inputCategory,
        company_name = _this$state.inputCompany;
      _this.props.fetchPage(null, {
        zone: zone,
        category: category,
        company_name: company_name
      });
    };
    _this.resetSearch = function () {
      _this.setState({
        inputZone: '',
        inputCategory: '',
        inputCompany: ''
      });
      _this.props.fetchPage();
    };
    _this.state = {
      currentSRId: 0,
      inputZone: '',
      inputCategory: '',
      inputCompany: ''
    };
    return _this;
  }
  _createClass(ExhibitorsGrid, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      if (this.props.i18n.language === 'es') _moment2.default.updateLocale('es', {
        ordinal: '%d'
      });
      var theme = (0, _styles.createMuiTheme)({
        palette: {
          primary: {
            main: '#FDAB2B'
          },
          secondary: {
            main: '#FDAB2B'
          }
        }
      });
      var _props = this.props,
        classes = _props.classes,
        cssProperties = _props.cssProperties,
        otherProperties = _props.otherProperties,
        entities = _props.entities,
        pagination = _props.pagination,
        fetchPage = _props.fetchPage,
        initCompleteFetchs = _props.initCompleteFetchs,
        responsiveMode = _props.responsiveMode,
        t = _props.t;
      var hideSearchBar = otherProperties.hideSearchBar,
        hideZoneFilter = otherProperties.hideZoneFilter,
        hideCompanyFilter = otherProperties.hideCompanyFilter,
        hideCategoryFilter = otherProperties.hideCategoryFilter;
      var isFetching = pagination.isFetching,
        idsByPage = pagination.idsByPage,
        links = pagination.links;
      var currentPage = links.self;
      var stand_reservations = !!idsByPage && !!idsByPage[currentPage] && idsByPage[currentPage].map(function (id) {
        return entities.stand_reservations[id];
      });
      var column_size = null;
      var input_size = null;
      switch (responsiveMode) {
        case _ResponsiveModes.DESKTOP:
          column_size = 3;
          input_size = 5;
          break;
        case _ResponsiveModes.TABLET:
          column_size = 6;
          input_size = 10;
          break;
        case _ResponsiveModes.MOBILE:
        default:
          column_size = 12;
          input_size = 10;
      }
      var modalStandReservation = void 0,
        modalCompany = void 0,
        modalStand = void 0,
        modalZone = void 0,
        modalEvent = void 0;
      var defaultFieldsWithNames = {};
      if (!!this.state.currentSRId) {
        modalStandReservation = entities.stand_reservations[this.state.currentSRId];
        if (!!modalStandReservation.company && !!modalStandReservation.company.id) modalCompany = entities.companies[modalStandReservation.company.id];
        if (!!modalStandReservation.stand && !!modalStandReservation.stand.id) modalStand = entities.stands[modalStandReservation.stand.id];
        if (!!modalStand && !!modalStand.zone && !!modalStand.zone.id) modalZone = entities.zones[modalStand.zone.id];
        if (!!modalStandReservation.event && !!modalStandReservation.event.id) modalEvent = entities.events[modalStandReservation.event.id];
      }
      return _react2.default.createElement('div', {
        className: classes.ExhibitorsGrid,
        style: cssProperties
      }, !hideSearchBar && _react2.default.createElement('div', {
        className: classes.searchPanel
      }, _react2.default.createElement(_styles.MuiThemeProvider, {
        theme: theme
      }, _react2.default.createElement(_Grid2.default, {
        container: true,
        className: classes.gridInputs,
        spacing: 24,
        justify: 'center'
      }, !hideZoneFilter && _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: hideCompanyFilter ? 10 : input_size
      }, _react2.default.createElement(_FormControl2.default, {
        className: classes.formControl
      }, _react2.default.createElement(_Select2.default, {
        value: this.state.inputZone,
        displayEmpty: true,
        name: 'Zone',
        className: classes.inputZone,
        InputProps: {
          classes: {
            root: classes.inputZone,
            input: classes.inputZoneInput
          }
        },
        onChange: this.handleChange('inputZone')
      }, _react2.default.createElement(_MenuItem2.default, {
        value: ''
      }, _react2.default.createElement('span', {
        className: classes.selectPlaceholder
      }, 'Zone')), isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        className: classes.progress,
        size: 50
      }) : !!entities.zones && Object.keys(entities.zones).map(function (key) {
        return _react2.default.createElement(_MenuItem2.default, {
          key: key,
          value: entities.zones[key].id
        }, entities.zones[key].name);
      })))), !hideCompanyFilter && _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: hideZoneFilter ? 10 : input_size
      }, _react2.default.createElement(_TextField2.default, {
        label: '',
        InputLabelProps: {
          shrink: true
        },
        placeholder: 'Company',
        value: this.state.inputCompany,
        onChange: this.handleChange('inputCompany'),
        fullWidth: true,
        InputProps: {
          classes: {
            root: classes.inputCompany,
            input: classes.inputCompanyInput
          }
        }
      })), !hideCategoryFilter && _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 10
      }, _react2.default.createElement(_FormControl2.default, {
        className: classes.formControl
      }, _react2.default.createElement(_Select2.default, {
        value: this.state.inputCategory,
        displayEmpty: true,
        name: 'category',
        className: classes.inputCategory,
        onChange: this.handleChange('inputCategory'),
        InputProps: {
          classes: {
            root: classes.inputCategory,
            input: classes.inputCategoryInput
          }
        }
      }, _react2.default.createElement(_MenuItem2.default, {
        value: ''
      }, _react2.default.createElement('span', {
        className: classes.selectPlaceholder
      }, 'Category')), isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        className: classes.progress,
        size: 50
      }) : !!entities.stand_categories && Object.keys(entities.stand_categories).map(function (key) {
        return _react2.default.createElement(_MenuItem2.default, {
          key: key,
          value: entities.stand_categories[key].id
        }, entities.stand_categories[key].name);
      })))), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12
      }, _react2.default.createElement(_Button2.default, {
        variant: 'contained',
        color: 'primary',
        className: (0, _classnames2.default)(classes.button, classes.searchButton),
        onClick: this.handleSubmit
      }, t('exhibitors.search')), _react2.default.createElement(_Button2.default, {
        variant: 'contained',
        color: 'primary',
        className: (0, _classnames2.default)(classes.button, classes.resetButton),
        onClick: this.resetSearch
      }, t('exhibitors.reset')))))), !!this.state.currentSRId && !!modalEvent && modalEvent.defaultProfileFields.map(function (field) {
        defaultFieldsWithNames[entities.custom_fields[field.id].name] = entities.custom_fields[field.id].langText;
      }), !!this.state.currentSRId && !!modalEvent && _react2.default.createElement(_CustomModal2.default, {
        onClose: this.handleClose
      }, _react2.default.createElement('div', {
        id: this.state.currentSRId,
        className: classes.modalExhibitor
      }, !!defaultFieldsWithNames['profile_logo'] && _react2.default.createElement('div', {
        className: 'img-wrapper'
      }, _react2.default.createElement('img', {
        alt: modalCompany.name || "",
        className: 'modal-logo',
        src: '' + (modalStandReservation.profileLogo.filename ? modalStandReservation.profileLogo.large : modalCompany.logo.filename ? modalCompany.logo.large : 'https://s3.amazonaws.com/eventtia-composer/assets/images/icons/company_logo.png')
      })), _react2.default.createElement('span', {
        className: 'modal-info'
      }, !!defaultFieldsWithNames['display_name'] && _react2.default.createElement('p', {
        className: 'modal-paragraph'
      }, _react2.default.createElement('span', null, _react2.default.createElement('strong', null, defaultFieldsWithNames['display_name'])), _react2.default.createElement('span', null, modalCompany.name)), !!defaultFieldsWithNames['website'] && !!modalStandReservation.website && _react2.default.createElement('p', {
        className: 'modal-paragraph'
      }, _react2.default.createElement('span', null, _react2.default.createElement('strong', null, defaultFieldsWithNames['website'])), _react2.default.createElement('span', null, _react2.default.createElement('a', {
        href: (0, _misc.prependHttpIfNeeded)(modalStandReservation.website),
        target: '_blank'
      }, modalStandReservation.website))), !!defaultFieldsWithNames['profile_description'] && !!modalStandReservation.profileDescription && _react2.default.createElement('p', {
        className: 'modal-paragraph'
      }, _react2.default.createElement('span', null, _react2.default.createElement('strong', null, defaultFieldsWithNames['profile_description'])), _react2.default.createElement('span', null, modalStandReservation.profileDescription)), !!modalCompany.email && _react2.default.createElement('p', {
        className: 'modal-paragraph'
      }, _react2.default.createElement('span', null, _react2.default.createElement('strong', null, 'Email')), _react2.default.createElement('span', null, '' + modalCompany.email)), !!modalEvent.extraProfileFields && !!modalEvent.extraProfileFields.length && modalEvent.extraProfileFields.map(function (field) {
        if (!!modalStandReservation.profileExtraFields && !!modalStandReservation.profileExtraFields[field.id] && modalStandReservation.profileExtraFields[field.id] !== '') {
          return _react2.default.createElement('p', {
            className: 'modal-paragraph',
            key: field.id
          }, _react2.default.createElement('span', null, _react2.default.createElement('strong', null, _this2.cleanString('' + entities.custom_fields[field.id].langText))), modalStandReservation.profileExtraFields[field.id] instanceof Object && !(modalStandReservation.profileExtraFields[field.id] instanceof Array) ? modalStandReservation.profileExtraFields[field.id].medium ? _react2.default.createElement('span', null, _react2.default.createElement('img', {
            className: 'profile-custom-field-image',
            src: '' + modalStandReservation.profileExtraFields[field.id].medium
          })) : (0, _misc.isCityObject)(modalStandReservation.profileExtraFields[field.id]) ? _react2.default.createElement('span', null, modalStandReservation.profileExtraFields[field.id].city) : _react2.default.createElement('span', null, _react2.default.createElement('a', {
            href: modalStandReservation.profileExtraFields[field.id].originalUrl
          }, t('text.click_here_file'))) : _this2.isURL(modalStandReservation.profileExtraFields[field.id]) ? _react2.default.createElement('span', null, _react2.default.createElement('a', {
            href: modalStandReservation.profileExtraFields[field.id],
            target: '_blank'
          }, modalStandReservation.profileExtraFields[field.id])) : _react2.default.createElement('span', null, modalStandReservation.profileExtraFields[field.id]));
        }
      })))), _react2.default.createElement(_Grid2.default, {
        container: true,
        className: classes.grid,
        spacing: 24,
        direction: 'row',
        justify: 'flex-start',
        alignItems: 'center'
      }, isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        className: classes.progress,
        size: 50
      }) : stand_reservations && !!stand_reservations.length ? stand_reservations.map(function (exhibitor) {
        var id = exhibitor.id,
          displayName = exhibitor.displayName,
          profileLogo = exhibitor.profileLogo;
        var identifier = entities.stands[exhibitor.stand.id].identifier;
        var _ref7 = entities.zones ? entities.stands[exhibitor.stand.id] ? entities.zones[entities.stands[exhibitor.stand.id].zone.id] : {} : {},
          zoneName = _ref7.name;
        var _entities$companies$e = entities.companies[exhibitor.company.id],
          companyName = _entities$companies$e.name,
          logo = _entities$companies$e.logo;
        var logoStyle = '' + (profileLogo.filename ? profileLogo.large : logo.filename ? logo.large : 'https://s3.amazonaws.com/eventtia-composer/assets/images/icons/company_logo.png');
        return _react2.default.createElement(_Grid2.default, {
          item: true,
          xs: column_size,
          key: id
        }, _react2.default.createElement('div', {
          key: id,
          id: id,
          onClick: function onClick() {
            _this2.showModal(id);
          },
          className: classes.exhibitor
        }, _react2.default.createElement('div', {
          className: 'stand-identifier'
        }, _react2.default.createElement('p', null, 'Stand ' + identifier)), _react2.default.createElement('div', {
          className: 'info'
        }, _react2.default.createElement('div', {
          className: 'img-wrapper'
        }, _react2.default.createElement('img', {
          className: 'logo',
          alt: companyName,
          src: logoStyle
        })), _react2.default.createElement('span', {
          className: 'specific-info'
        }, _react2.default.createElement('p', {
          className: 'company-name'
        }, companyName), _react2.default.createElement('p', {
          className: 'zone-name'
        }, zoneName)))));
      }) : _react2.default.createElement('h3', {
        className: classes.noExhibitor
      }, 'No exhibitors')), stand_reservations && !!stand_reservations.length && (links.next || links.prev) && _react2.default.createElement(_Paginator2.default, _extends({
        fetchPage: fetchPage
      }, links)));
    }
  }]);
  return ExhibitorsGrid;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(ExhibitorsGrid));